export class ThemeComponent {
  constructor({ dark, colors }) {
    this.dark = dark
    this.colors = colors
  }
}
